import React from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import GuideLink from '../components/GuideLink';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';

const GuideNoticeOverview: React.FC = () => {
  return (
    <GuidePageLayout
      title="通知管理"
      description="通知・お知らせの作成・管理・確認を行う機能です。管理者が個人向け通知や全体お知らせを配信し、ユーザーが通知を確認・解決します。"
    >
      <GuideSection title="ガイド一覧">
        <Stack spacing={1.5}>
          <Stack spacing={0.5}>
            <GuideLink to="notice/create-notice">特定ユーザーに通知を送る</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              特定のユーザーに対して個別通知を作成・送信します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="notice/create-info">全ユーザーにお知らせを配信する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              全ユーザー向けのお知らせを作成・配信します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="notice/admin-manage">通知を管理する（編集・削除・解決・検索）</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              管理者として通知の編集・削除・解決・検索を行います。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="notice/user">通知を確認・操作する（ユーザー）</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              受信した通知やお知らせを確認・操作します。
            </Typography>
          </Stack>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideNoticeOverview;
